import { h, render } from "preact";
import MiniCartContent from "./mini-cart-content/mini-cart-content";
import "./mini-cart-count";
import "./mini-cart-upsells";
import "./mini-cart-upsells-carousel";

class MiniCartDrawer extends HTMLElement {
  constructor() {
    super();

    this.content = this.querySelector(".mini-cart__content");
    this.data = window.scrapeSectionData(this);

    this.addEventListener("click", (e) => {
      if (!e.target.closest("[data-close]")) return;

      this._close();
    });

    this.handleDocumentClick = (e) => {
      // Ignore clicks on items no longer in DOM
      if (!document.body.contains(e.target)) return;

      if (!this.content.contains(e.target)) {
        this._close();
      }
    };

    document.addEventListener("click", this.handleDocumentClick);

    this.closeEsc = (e) => {
      if (e.key === "Escape") {
        this._close();
      }
    };

    document.addEventListener("keydown", this.closeEsc);

    document.addEventListener("mini-cart:open", () => this._open());
    document.addEventListener("mini-cart:close", () => this._close());

    if (new URL(window.location).searchParams.has("cart")) {
      this._open();
    }
  }

  connectedCallback() {
    render(
      <MiniCartContent
        message={this.data?.message}
        emptyMessage={this.data?.emptyMessage}
        swatchWarning={this.data?.swatchWarning}
        mixedSwatchTypesWarning={this.data?.mixedSwatchTypesWarning}
        emptyCtaCopy={this.data?.emptyCtaCopy}
        emptyCtaUrl={this.data?.emptyCtaUrl}
        swatchLimitEach={this.data?.swatchLimitEach}
        showQuotes={this.data?.showQuotes}
        quotesUrl={this.data?.quotesUrl}
        countryCode={this.data?.countryCode}
      />,
      this.querySelector("[data-container]"),
    );
  }

  disconnectedCallback() {
    document.removeEventListener("keydown", this.closeEsc);
    document.removeEventListener("click", this.handleDocumentClick);
  }

  _toggle() {
    this.hasAttribute("open") ? this._close() : this._open();
  }

  _open() {
    if (this.hasAttribute("open")) return;

    this.style.display = "block";
    window.requestAnimationFrame(() => {
      this.setAttribute("open", "");
      window.openFullDimmer(this);
      window.lockScroll(this);
      this.returnFocusEl = document.activeElement;
      window.trapFocus(this, this.closeButton);
    });
  }

  _close() {
    if (!this.hasAttribute("open")) return;

    this.removeAttribute("open");
    window.removeTrapFocus(this.returnFocusEl);
    window.closeFullDimmer(this);

    const onEnd = () => {
      this.removeEventListener("transitionend", onEnd);

      if (this.hasAttribute("open")) return;
      this.style.display = null;
      window.unlockScroll(this);
    };
    this.addEventListener("transitionend", onEnd);
  }
}

if (!customElements.get("mini-cart-drawer")) {
  customElements.define("mini-cart-drawer", MiniCartDrawer);
}
